/** สีผิว: มนุษย์หลายโทน + โทนเผ่าแฟนตาซี (ม่วงอ่อน เขียวใบไม้ เทาม่วง ทอง) */
export const SKIN_COLORS = Object.freeze([
    "#ffe3cc", "#ffd9b8", "#f2c29b", "#d9a07a", "#b97c55", "#8a5a3b",
    "#e6d8f5", "#d8eec0", "#c9bdd6", "#f2d48a",
]);
/** สีผม (เกมย้อมชิ้นผม) */
export const HAIR_COLORS = Object.freeze([
    "#241f2e", "#3a2c22", "#6b4325", "#a0642e", "#e8c06a", "#f4f1ff",
    "#c9d3df", "#e04a3a", "#ff8fb0", "#b06cff", "#4a7dff", "#3fc6c0",
    "#5bbf4a", "#ffb03a", "#7a7f8a", "#1f3a6b",
]);
/** สีตา */
export const EYE_COLORS = Object.freeze([
    "#1d1d2b", "#5a3a22", "#2f6fd6", "#2f9a5a", "#8a3fd0", "#d03a3a", "#e8a21a", "#3fb8c0",
]);
/** ทรงผม 12 แบบ (ออกแบบเอง) — ลำดับนี้คือลำดับปุ่มในหน้าสร้างตัวละคร */
export const HAIR_STYLES = Object.freeze([
    { id: "spiky", th: "ชี้ฟู" },
    { id: "swept", th: "ปัดข้าง" },
    { id: "messy", th: "ยุ่งน่ารัก" },
    { id: "bob", th: "บ็อบ" },
    { id: "twintails", th: "แกละคู่" },
    { id: "ponytail", th: "หางม้า" },
    { id: "bun", th: "มวยบน" },
    { id: "braid", th: "เปียข้าง" },
    { id: "curly", th: "หยิกฟู" },
    { id: "mohawk", th: "หงอนกลาง" },
    { id: "bowl", th: "กะลา" },
    { id: "wavy", th: "ยาวสลวย" },
]);
const STYLE_IDS = new Set(HAIR_STYLES.map((h) => h.id));
const HEX = /^#[0-9a-f]{6}$/i;
/** ค่าเริ่มต้นตามเพศ + สีผมประจำอาชีพ (หน้าตาเดิมก่อนมีระบบนี้: หญิงผมยาว ชายผมชี้) */
export function defaultLook(gender, classHair = "#3a2c22") {
    return { skin: "#ffd9b8", hair: classHair, hairStyle: gender === "female" ? "wavy" : "spiky", eyes: "#1d1d2b" };
}
/**
 * อ่านหน้าตาจากภายนอก (HTTP / join options / ฐานข้อมูล / state) ให้อยู่ในกติกาเสมอ
 * สีต้องอยู่ในพาเลต (กันใส่สีอะไรก็ได้ เช่นโปร่งใส/ดำสนิทจนมองไม่เห็นตัว) · ทรงผมต้องมีจริง
 */
export function parseLook(raw, gender, classHair) {
    const base = defaultLook(gender, classHair);
    let o;
    if (typeof raw === "string" && raw.length > 0 && raw.length < 400) {
        try {
            o = JSON.parse(raw);
        }
        catch {
            o = undefined;
        }
    }
    else if (raw && typeof raw === "object") {
        o = raw;
    }
    if (!o)
        return base;
    const pick = (v, list, fb) => typeof v === "string" && HEX.test(v) && list.includes(v.toLowerCase()) ? v.toLowerCase() : fb;
    return {
        skin: pick(o["skin"], SKIN_COLORS, base.skin),
        hair: typeof o["hair"] === "string" && HEX.test(o["hair"])
            && (HAIR_COLORS.includes(o["hair"].toLowerCase()) || o["hair"].toLowerCase() === base.hair.toLowerCase())
            ? o["hair"].toLowerCase() : base.hair,
        hairStyle: typeof o["hairStyle"] === "string" && STYLE_IDS.has(o["hairStyle"]) ? o["hairStyle"] : base.hairStyle,
        eyes: pick(o["eyes"], EYE_COLORS, base.eyes),
    };
}
/** เก็บเป็นสตริงสั้น (ฐานข้อมูล / state) */
export function encodeLook(l) {
    return JSON.stringify({ skin: l.skin, hair: l.hair, hairStyle: l.hairStyle, eyes: l.eyes });
}
/** สุ่มหน้าตา (ปุ่มสุ่มในหน้าสร้างตัวละคร) — rng ส่งเข้ามา (client ใช้ Math.random) */
export function randomLook(rng) {
    const pick = (xs) => xs[Math.floor(rng() * xs.length)];
    return { skin: pick(SKIN_COLORS), hair: pick(HAIR_COLORS), hairStyle: pick(HAIR_STYLES).id, eyes: pick(EYE_COLORS) };
}
//# sourceMappingURL=looks.js.map